import type { CdekAssignedCourierData, CdekTrackingData } from './api/schemas/cdek.schema'
import { latestCdekStatus } from './cdek-status-history'
import { renderCourierTemplate } from './template'

export const COURIER_WAITING_TEXT = 'Сообщение появится здесь, как только СДЭК назначит курьера.'
export const COURIER_NOT_RECEIVED_TEXT = 'СДЭК не прислал данные курьера'
export const COURIER_INCOMPLETE_TEXT = 'СДЭК не прислал имя или телефон курьера'
export const COURIER_NEEDS_BUYER_TEXT = 'Добавьте имя покупателя, чтобы подготовить сообщение.'

const ABSENT_VEHICLE_VALUE = 'не указан'

/** The courier a COURIER_INFO webhook delivered; the provider document's `courier` is never read. */
export function assignedCourier(tracking?: CdekTrackingData | null): CdekAssignedCourierData | null {
  const assignment = tracking?.courierAssignment
  return assignment?.state === 'assigned' ? assignment.courier : null
}

export function courierMessageEmptyText(tracking?: CdekTrackingData | null): string {
  const courier = assignedCourier(tracking)
  if (courier) return courier.name && courier.phone ? COURIER_NEEDS_BUYER_TEXT : COURIER_INCOMPLETE_TEXT
  if (
    tracking?.courierAssignment?.state === 'not_received'
    && latestCdekStatus(tracking.statuses)?.code === 'TAKEN_BY_COURIER'
  ) {
    return COURIER_NOT_RECEIVED_TEXT
  }
  return COURIER_WAITING_TEXT
}

export function composeCourierMessage(
  template: string,
  tracking: CdekTrackingData | null | undefined,
  data: { firstName: string; cdekNumber: string; confirmationCode?: string },
): string | null {
  const courier = assignedCourier(tracking)
  if (!data.firstName || !courier?.name || !courier.phone) return null
  return renderCourierTemplate(template, {
    firstName: data.firstName,
    courierName: courier.name,
    courierPhone: courier.phone,
    courierCar: courier.car_model || ABSENT_VEHICLE_VALUE,
    courierPlate: courier.registration_mark || ABSENT_VEHICLE_VALUE,
    cdekNumber: data.cdekNumber,
    confirmationCode: data.confirmationCode,
  })
}
